import LeftPanel, { hideLeftPanel } from 'common/components/leftPanel'
import { useAppDispatch } from 'common/hooks/redux'

import ElementsList from './ElementsList'

type Props = {
  selectedPersonalizationId: string | undefined
  onSelectPersonalization: (personalizationId: string | undefined) => void
  statusFilter?: string
}

const LeftSection = ({
  selectedPersonalizationId,
  onSelectPersonalization,
  statusFilter,
}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <LeftPanel onOutsideClick={() => dispatch(hideLeftPanel())}>
      <div className="flex flex-col gap-6">
        <ElementsList
          selectedPersonalizationId={selectedPersonalizationId}
          onSelectPersonalization={onSelectPersonalization}
          statusFilter={statusFilter}
        />
      </div>
    </LeftPanel>
  )
}

export default LeftSection
